<div class="container-fluid p-3 bg-amber-50">
  <div class="bg-white rounded-md  border-2 border-blue-900 border-gray-300 px-4 py-2 sm:p-6 mb-4">
    <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
      <div class="flex gap-3">

        <div class="flex-1">
          <h4 class="text-xl sm:text-2xl font-bold text-slate-800 mb-1">
            {{stepDetails?.name}}
          </h4>

          <h5 class="text-base sm:text-lg text-blue-600 font-semibold mb-3">
            [{{ proposalName }}]
          </h5>


        </div>
        <div>

          <span class="inline-flex items-center px-3 py-1.5 border-2 rounded-full text-sm font-bold transition-all"
            [ngClass]="{
                        'bg-slate-100 text-slate-700 border border-slate-500': stepDetails?.step_status == 0,
                        'bg-emerald-100 text-emerald-700 border border-emerald-500': stepDetails?.step_status == 'approved',
                        'bg-amber-100 text-amber-700 border border-amber-500': stepDetails?.step_status == 'recommended',
                        'bg-blue-100 text-blue-700 border border-blue-500': stepDetails?.step_status == 'initiated'
                      }">
            <span class="w-2 h-2 rounded-full mr-2 animate-pulse" [ngClass]="{
                          'bg-slate-500': stepDetails?.step_status == 0,
                          'bg-emerald-500': stepDetails?.step_status == 'approved',
                          'bg-amber-500': stepDetails?.step_status == 'recommended',
                          'bg-blue-500': stepDetails?.step_status == 'initiated'
                        }"></span>
            {{ stepDetails?.step_status == 0 ? " PENDING" : (stepDetails?.step_status | uppercase) }}
          </span>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="flex flex-wrap items-center gap-2">

        <!-- <button class="bg-red-500 text-white rounded text-sm me-2 p-2" (click)="generatePDF()">
          <i class="pi pi-file-pdf me-1"></i> PDF
        </button> -->
        <!-- <button class="bg-green-600 text-white rounded text-sm me-2 p-2" (click)="printForm()">
          <i class="pi pi-print me-1"></i> Print
        </button> -->
        <ng-container *ngIf="stepDetails?.can_edit">
          <button (click)="routeConfig.emit({isRouteConfig: true})"
            class="inline-flex items-center px-4 py-2.5 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:bg-slate-300 disabled:cursor-not-allowed transition-all duration-200 font-medium text-sm shadow-sm hover:shadow-md">
            <i class="pi pi-save mr-2"></i> Save/Forward/Route Config
          </button>
        </ng-container>
      </div>
    </div>
  </div>

  <hr class="my-3" />
  <div class="max-w-full mx-auto text-sm space-y-4">


    <hr class="border-slate-100" *ngIf="needGenData" />

    <form *ngIf="!(['makeI','makeII','makeIII'].includes(schemeType))" [formGroup]="challengeForm" class="space-y-3">

      <div class="border border-slate-200 rounded-lg overflow-hidden bg-white shadow-sm">
        <div (click)="expandedSections['detailedInfo'] = !expandedSections['detailedInfo']"
          class="flex items-center justify-between p-3 cursor-pointer hover:bg-slate-50 transition-colors">
          <div class="flex items-center gap-2">
            <span class="p-1.5 rounded bg-blue-100 text-blue-600"><i class="pi pi-list text-xs"></i></span>
            <h3 class="font-bold text-slate-700 text-xs uppercase tracking-wider">Detailed Information</h3>
          </div>
          <i class="pi text-slate-400 text-[10px]"
            [ngClass]="expandedSections['detailedInfo'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
        </div>

        <div *ngIf="expandedSections['detailedInfo']"
          class="p-4 border-t border-slate-100 grid grid-cols-1 gap-4 bg-slate-50/30">
          <div *ngFor="let field of [
            {label:'Essential Parameters', ctrl:'essentialParameters'},
            {label:'Desirable Parameters', ctrl:'desirableParameters'},
            {label:'Functional Requirements', ctrl:'functionalRequirements'},
            {label:'Performance Requirements', ctrl:'performanceRequirements'},
            {label:'Technical Requirements', ctrl:'technicalRequirements'},
            {label:'Operational Requirements', ctrl:'operationalRequirements'}
          ]" class="space-y-1">
            <p class="text-[10px] font-bold text-blue-700 uppercase ml-1">{{field.label}}</p>
            <div class="border border-slate-200 rounded bg-white" [class.opacity-60]="isEditorDisabled">
              <editor [init]="init" [formControlName]="field.ctrl" [disabled]="isEditorDisabled"></editor>
            </div>
          </div>
        </div>
      </div>

      <div class="border border-slate-200 rounded-lg overflow-hidden bg-white shadow-sm">
        <div (click)="expandedSections['additionalInfo'] = !expandedSections['additionalInfo']"
          class="flex items-center justify-between p-3 cursor-pointer hover:bg-slate-50">
          <div class="flex items-center gap-2">
            <span class="p-1.5 rounded bg-purple-100 text-purple-600"><i class="pi pi-plus text-xs"></i></span>
            <h3 class="font-bold text-slate-700 text-xs uppercase tracking-wider">Additional Information</h3>
          </div>
          <i class="pi text-slate-400 text-[10px]"
            [ngClass]="expandedSections['additionalInfo'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
        </div>
        <div *ngIf="expandedSections['additionalInfo']" class="p-4 border-t border-slate-100 space-y-4 bg-slate-50/30">
          <div *ngFor="let field of [
            {label:'Logistical Requirements', ctrl:'logisticalRequirements'},
            {label:'Cost Requirements', ctrl:'costRequirements'},
            {label:'Timeline Requirements', ctrl:'timelineRequirements'},
            {label:'Additional Requirements', ctrl:'addRequirements'}
          ]" class="space-y-1">
            <p class="text-[10px] font-bold text-purple-700 uppercase ml-1">{{field.label}}</p>
            <div class="border border-slate-200 rounded bg-white">
              <editor [init]="init" [formControlName]="field.ctrl" [disabled]="isEditorDisabled"></editor>
            </div>
          </div>
        </div>
      </div>
    </form>

    <form *ngIf="(['makeI','makeII','makeIII'].includes(schemeType))" [formGroup]="challengeForm" class="space-y-3">

      <!-- <div class="border border-slate-200 rounded-lg overflow-hidden bg-white shadow-sm">
        <div (click)="expandedSections['detailedInfo'] = !expandedSections['detailedInfo']"
          class="flex items-center justify-between p-3 cursor-pointer hover:bg-slate-50">
          <div class="flex items-center gap-2">
            <span class="p-1.5 rounded bg-indigo-100 text-indigo-600"><i class="pi pi-list text-xs"></i></span>
            <h3 class="font-bold text-slate-700 text-xs uppercase tracking-wider">Detailed Information (Make)</h3>
          </div>
          <i class="pi text-slate-400 text-[10px]"
            [ngClass]="expandedSections['detailedInfo'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
        </div> -->
        <!-- <div *ngIf="expandedSections['detailedInfo']" class="p-4 border-t border-slate-100 space-y-4 bg-slate-50/30">
          <ng-container *ngFor="let section of psqrSections">
            <div class="space-y-1">
              <p class=" font-bold text-indigo-700 uppercase ml-1">{{ section.label }}</p>
              <div class="border border-slate-200 rounded bg-white">
                <editor [init]="init" [formControlName]="section.key" [disabled]="isEditorDisabled"></editor>
              </div>
            </div>
          </ng-container>
        </div> -->
        
      <!-- </div> -->
       <div class="editor-field mt-4">
        <p class="bg-blue-500 p-2 text-white font-medium">SQR Content</p>
        <editor [init]="sqrEditorInit" [formControlName]="'introduction'" ></editor>
      </div>


    </form>

    <!-- SQR Editor Section -->
    <!-- <form [formGroup]="commentForm">
      <div class="editor-field mt-4">
        <p class="bg-blue-500 p-2 text-white font-medium">SQR Content</p>
        <editor [init]="sqrEditorInit" [formControlName]="'introduction'" [disabled]="isEditorDisabled"></editor>
      </div>
    </form> -->

    <div class="border border-slate-200 rounded-lg overflow-hidden bg-white shadow-sm">
      <div (click)="expandedSections['uploads'] = !expandedSections['uploads']"
        class="flex items-center justify-between p-3 cursor-pointer hover:bg-slate-50 transition-colors">
        <div class="flex items-center gap-2">
          <span class="p-1.5 rounded bg-emerald-100 text-emerald-600"><i class="pi pi-upload text-xs"></i></span>
          <h3 class="font-bold text-slate-700 text-xs uppercase tracking-wider">Step Document Uploads</h3>
        </div>
        <i class="pi text-slate-400 text-[10px]"
          [ngClass]="expandedSections['uploads'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
      </div>
      <div *ngIf="expandedSections['uploads']" class="p-4 border-t border-slate-100 bg-white animate-fade-in">
        <app-upload-document [isEditable]="stepDetails?.can_edit"></app-upload-document>
      </div>
    </div>

  </div>
</div>